import React from "react";
import { useMemo } from "react";
import styled from "styled-components";

const Wrap = styled.div`
  position: absolute;
  left: 50%;
  top: 146px;
  transform: translateX(-50%) translateY(0);
  transform-origin: center center;
  background-color: #39b54a;
  color: #fff;
  padding: 20px 50px 20px 130px;
  border-radius: 70px;
  font-size: 60px;
  font-family: Noto Sans SC;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  border: 10px solid #0a7018;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  word-break: break-all;
  white-space: nowrap;
  &:before {
    content: "";
    position: absolute;
    left: 45px;
    top: 50%;
    transform: translateY(-50%);
    width: 84px;
    height: 64px;
    background: url(${require("@assets/img/cardgame/card_word_check.png")})
      no-repeat;
    background-size: 70% 70%;
  }
  .w1 {
    margin-top: -8px;
    display: block;
    position: relative;
    flex: none;
  }
  .w2 {
    top: 0px;
    margin-top: -8px;
    display: block;
    position: relative;
    color: #eed800;
    margin-left: 20px;
    flex: none;
  }
`;

const CardGameWord = ({ refs, word }) => {
  const renderWord = useMemo(() => {
    const words = word.split("|");
    if (words.length === 1) {
      return (
        <div className="w2" dangerouslySetInnerHTML={{ __html: words[0] }} />
      );
    } else {
      return (
        <>
          {/* {words[0] + " " + words[1]} */}
          <span className="w1" dangerouslySetInnerHTML={{ __html: words[0] }} />
          <span className="w2" dangerouslySetInnerHTML={{ __html: words[1] }} />
        </>
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [word]);

  return <Wrap ref={refs}>{renderWord}</Wrap>;
};

export default CardGameWord;
